import { useCallback, useEffect, useRef, useState } from "react";

export interface FadeInImageProps {
  loaded: boolean;
  ref: (node: HTMLImageElement | null) => void;
  onLoad: () => void;
}

export function useFadeInImage(src: string | null | undefined): FadeInImageProps {
  const [loaded, setLoaded] = useState(false);
  const imgRef = useRef<HTMLImageElement | null>(null);

  const ref = useCallback((node: HTMLImageElement | null) => {
    imgRef.current = node;
    if (node) setLoaded(Boolean(node.complete && node.naturalWidth > 0));
  }, []);

  useEffect(() => {
    const img = imgRef.current;
    setLoaded(Boolean(img && img.complete && img.naturalWidth > 0));
  }, [src]);

  const onLoad = useCallback(() => setLoaded(true), []);

  return { loaded, ref, onLoad };
}
